module.exports = __webpack_public_path__ + "27c7ed579a188237c4dd2a2d4e78788f.png";